import {
  SAVE_NPS_BASIC_DETAILS,
  SAVE_NPS_BANK_DETAILS,
  SAVE_NPS_REJECTION_DETAILS,
  SAVE_NPS_STATUS,
  GENERATE_ONBOARD_LINK_SUCCESS,
  SAVE_NPS_ACTIVE_BODY,
  SAVE_AGENT_REFNO,
} from "../types/nps";

const initialState = {
  Nps_Basic_Details: {},
  Nps_Bank_Details: {},
  Nps_Rejection_Details: {},
  Status_Codes: [],
  Onboarding_URL: "",
  Active_Body: {},
};
export function npsReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_NPS_BASIC_DETAILS: {
      return {
        ...state,
        Nps_Basic_Details: action.body,
      };
    }
    case "NPS_ENABLE_ADDITIONAL_PURCHASE": {
      return { ...state, isAdditionalPurchaseEnabled: true };
    }
    case SAVE_NPS_BANK_DETAILS: {
      return {
        ...state,
        Nps_Bank_Details: action.body,
      };
    }
    case SAVE_NPS_REJECTION_DETAILS: {
      return {
        ...state,
        Nps_Rejection_Details: action.body,
      };
    }
    case SAVE_NPS_STATUS: {
      return {
        ...state,
        Status_Codes: action.body,
      };
    }
    case SAVE_AGENT_REFNO: {
      return {
        ...state,
        RefNo: action.body,
      };
    }
    case GENERATE_ONBOARD_LINK_SUCCESS: {
      return {
        ...state,
        Onboarding_URL: action.body,
      };
    }
    case SAVE_NPS_ACTIVE_BODY: {
      return {
        ...state,
        Active_Body: action.body,
      };
    }
    default:
      return state;
  }
}
